export default "__VITE_ASSET__Dm7ZjJnM__"